import { take } from 'rxjs/operators';
import { FbSummaryStatusDasboardCardService } from './fb-summary-status-dasboard-card.service';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CustomButtonActionService } from 'custom-button-action';
import * as moment from 'moment';
import { FormDesignerService } from '../../form-designer/form-designer.service';

interface Content {
  type: string;
  title: string;
  footerLink: string;
  employeeList?: boolean;
  apiValue: string;
  dashboardRedirectPageFormId?: number;
}

interface Status {
  name: string;
  value: any;
}

@Component({
  selector: 'app-fb-summary-status-dasboard-card',
  templateUrl: './fb-summary-status-dasboard-card.component.html',
  styleUrls: ['./fb-summary-status-dasboard-card.component.scss']
})
export class FbSummaryStatusDasboardCardComponent implements OnChanges {
  @Input() content: Content;
  statusList: Status[];
  employeeList: any[];

  constructor(
    private fbSummaryStatusDasboardCardService: FbSummaryStatusDasboardCardService,
    private customButtonActionService: CustomButtonActionService,
    private formDesignerService: FormDesignerService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.content && changes.content.currentValue?.apiValue !== changes.content.previousValue?.apiValue) {
      this.fetchDetails();
    }
  }

  private fetchDetails(): void {
    if (this.content) {
      let req;
      if (this.content.title === 'Employee Check-in Summary') {
        const encodedDate = encodeURIComponent(moment().format('YYYY-MM-DD'));
        req = this.fbSummaryStatusDasboardCardService.getCheckInSummaryDetails(this.content.apiValue, encodedDate);
      } else {
        req = this.fbSummaryStatusDasboardCardService.getDetails(this.content.apiValue);
      }
      // if (this.content.title === 'Employee Check-in Summary') {
      //   const data = {
      //     'On Time checked-in': 18,
      //     'Late Checked-in': 9
      //   };
      //   this.setStatusList(data);
      // } else {
      req
        .pipe(take(1))
        .subscribe((data: any) => {
          if (data) {
            this.setStatusList(data);
            if (this.content.employeeList) {
              this.employeeList = data.fbDashboardEmployeeDetailsList?.length > 0 ? data.fbDashboardEmployeeDetailsList : [];
              this.employeeList = data.fbDashboardEmployeeDetailsList.map(x => {
                const profilePicBase64 = x['smallProfilePic'];
                return {
                  ...x,
                  profilePicBase64: profilePicBase64
                  ? `data:image/jpeg;base64,${profilePicBase64}`
                  : null
                }
              });
            }
          }
        });
      // }
    }
  }

  setStatusList(data) {
    this.statusList = Object.keys(data)
      .filter(key => key !== 'fbDashboardEmployeeDetailsList')
      .map(key => {
        return {
          name: key,
          value: data[key] ? data[key] : 0
        };
      });
  }

  footerRedirect() {
    sessionStorage.removeItem('redirectId');
    sessionStorage.setItem('redirectId', this.content.dashboardRedirectPageFormId.toString());
    this.formDesignerService.setDashboardLink(true);
    this.customButtonActionService.getPageFormById(this.content.dashboardRedirectPageFormId)
      .pipe(take(1)).subscribe((response: any) => {
        if (response) {
          const item = {
            formType: response.buildFormatTypeId,
            pageFormId: response.id
          }
          // if (this.isBeneficiaryProfileListing) {
          //   sessionStorage.setItem('FbEmployeeId', rowData.fb_beneficiaryId);
          //   sessionStorage.setItem('FbActualEmployeeId', rowData.fb_employeeId);
          // } else {
          // sessionStorage.setItem('formDataId', rowData.id);
          // }
          this.customButtonActionService.onLinkRedirectPageSubject.next(item);
        }
      });
  }

}
